import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { defaultDashboardGuard } from './core/guards/default-dashboard.guard';
import {
  moduleLandingGuard,
  permissionGuard,
} from './core/guards/permission.guard';
import { LayoutComponent } from './layout/layout.component';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [defaultDashboardGuard],
        loadComponent: () =>
          import(
            './pages/dashboard/shipments-dashboard/shipments-dashboard.component'
          ).then((m) => m.ShipmentsDashboardComponent),
        pathMatch: 'full',
        data: { breadcrumb: 'home' },
      },

      // Feature Modules
      {
        path: 'import',
        canActivate: [
          permissionGuard(['customsShipment.read', 'declaration.read']),
        ],
        data: { breadcrumb: 'import' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            canActivate: [
              moduleLandingGuard([
                {
                  path: '/import/shipments',
                  permission: 'customsShipment.read',
                },
                {
                  path: '/import/declarations',
                  permission: 'declaration.read',
                },
              ]),
            ],
            children: [],
          },
          {
            path: 'shipments',
            title: 'importShipments',
            data: { breadcrumb: 'importShipments' },
            canActivate: [permissionGuard('customsShipment.read')],
            loadComponent: () =>
              import('./pages/shipments/list/shipments-list.component').then(
                (m) => m.ShipmentsListComponent
              ),
          },
          {
            path: 'declarations',
            title: 'importDeclarations',
            data: { breadcrumb: 'importDeclarations' },
            canActivate: [permissionGuard('declaration.read')],
            loadComponent: () =>
              import(
                './pages/declarations/declarations-list/declarations-list.component'
              ).then((m) => m.DeclarationsListComponent),
          },
          {
            path: 'shipment-errors',
            title: 'shipmentError',
            data: { breadcrumb: 'shipmentError' },
            canActivate: [permissionGuard('customsShipment.read')],
            loadComponent: () =>
              import('./pages/shipments/list/shipments-list.component').then(
                (m) => m.ShipmentsListComponent
              ),
          },
          {
            path: 'declaration-errors',
            title: 'declarationError',
            data: { breadcrumb: 'declarationError' },
            canActivate: [permissionGuard('declaration.read')],
            loadComponent: () =>
              import(
                './pages/declarations/declarations-list/declarations-list.component'
              ).then((m) => m.DeclarationsListComponent),
          },
        ],
      },
      {
        path: 'export',
        canActivate: [
          permissionGuard(['customsShipment.read', 'declaration.read']),
        ],
        data: { breadcrumb: 'export' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            canActivate: [
              moduleLandingGuard([
                {
                  path: '/export/shipments',
                  permission: 'customsShipment.read',
                },
                {
                  path: '/export/declarations',
                  permission: 'declaration.read',
                },
              ]),
            ],
            children: [],
          },
          {
            path: 'shipments',
            title: 'exportShipments',
            data: { breadcrumb: 'exportShipments' },
            canActivate: [permissionGuard('customsShipment.read')],
            loadComponent: () =>
              import('./pages/shipments/list/shipments-list.component').then(
                (m) => m.ShipmentsListComponent
              ),
          },
          {
            path: 'declarations',
            title: 'exportDeclarations',
            data: { breadcrumb: 'exportDeclarations' },
            canActivate: [permissionGuard('declaration.read')],
            loadComponent: () =>
              import(
                './pages/declarations/declarations-list/declarations-list.component'
              ).then((m) => m.DeclarationsListComponent),
          },
          {
            path: 'shipment-errors',
            title: 'shipmentError',
            data: { breadcrumb: 'shipmentError' },
            canActivate: [permissionGuard('customsShipment.read')],
            loadComponent: () =>
              import('./pages/shipments/list/shipments-list.component').then(
                (m) => m.ShipmentsListComponent
              ),
          },
          {
            path: 'declaration-errors',
            title: 'declarationError',
            data: { breadcrumb: 'declarationError' },
            canActivate: [permissionGuard('declaration.read')],
            loadComponent: () =>
              import(
                './pages/declarations/declarations-list/declarations-list.component'
              ).then((m) => m.DeclarationsListComponent),
          },
        ],
      },
      {
        path: 'dashboard',
        canActivate: [
          permissionGuard([
            'misc.readGlobalStats',
            'customsShipment.stats',
            'customsShipment.read',
            'declaration.read',
            'transit.read',
            'emcs.read',
            'rto.read',
          ]),
        ],
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES
          ),
        data: { breadcrumb: 'dashboard' },
      },
      {
        path: 'shipments',
        canActivate: [permissionGuard('customsShipment.read')],
        loadChildren: () =>
          import('./pages/shipments/shipments.routes').then(
            (m) => m.SHIPMENTS_ROUTES
          ),
        data: { breadcrumb: 'shipments' },
      },
      {
        path: 'declarations',
        canActivate: [permissionGuard('declaration.read')],
        loadChildren: () =>
          import('./pages/declarations/declarations.routes').then(
            (m) => m.DECLARATIONS_ROUTES
          ),
        data: { breadcrumb: 'declarations' },
      },
      {
        path: 'transit-declarations',
        canActivate: [permissionGuard('transit.read')],
        loadChildren: () =>
          import(
            './pages/transit-declarations/transit-declarations.routes'
          ).then((m) => m.TRANSIT_DECLARATIONS_ROUTES),
        data: { breadcrumb: 'transitNcts' },
      },
      {
        path: 'emcs',
        canActivate: [permissionGuard('emcs.read')],
        loadChildren: () =>
          import('./pages/emcs/emcs.routes').then((m) => m.EMCS_ROUTES),
        data: { breadcrumb: 'emcs' },
      },
      {
        path: 'rto',
        canActivate: [permissionGuard('rto.read')],
        loadChildren: () =>
          import('./pages/rto/rto.routes').then((m) => m.RTO_ROUTES),
        data: { breadcrumb: 'pgts' },
      },
      {
        path: 'tickets',
        canActivate: [permissionGuard('ticket.read')],
        loadChildren: () =>
          import('./pages/tickets/tickets.routes').then((m) => m.ticketRoutes),
        data: { breadcrumb: 'tasks' },
      },
      {
        path: 'settings',
        canActivate: [
          permissionGuard([
            'broker.read',
            'client.read',
            'user.read',
            'declarationTemplate.read',
            'manifestTemplate.read',
            'role.read',
            'misc.readEmailLogs',
          ]),
        ],
        loadChildren: () =>
          import('./pages/settings/settings.routes').then(
            (m) => m.settingRoutes
          ),
        data: { breadcrumb: 'globalModules' },
      },
      {
        path: 'email',
        // Email Logs is controlled by Miscellaneous → View Email Logs
        // (`misc.readEmailLogs`), not the Email module View flag.
        canActivate: [permissionGuard('misc.readEmailLogs')],
        loadChildren: () =>
          import('./pages/email/email.routes').then((m) => m.emailRoutes),
        data: { breadcrumb: 'globalModules' },
      },
      {
        path: 'commodity-classifier',
        canActivate: [permissionGuard('commodityClassifier.read')],
        loadChildren: () =>
          import(
            './pages/commodity-classifier/commodity-classifier.routes'
          ).then((m) => m.commodityClassifierRoutes),
        data: { breadcrumb: 'commodityClassifier' },
      },

      // Shared / Misc Pages
      {
        path: 'alerts/all',
        canActivate: [permissionGuard('alert.read')],
        title: 'alerts',
        data: { breadcrumb: 'alerts' },
        loadComponent: () =>
          import('./pages/alerts/alerts-list/alerts-list.component').then(
            (m) => m.AlertsListComponent
          ),
      },
      {
        path: 'notifications/all',
        title: 'notifications',
        data: { breadcrumb: 'notifications' },
        loadComponent: () =>
          import(
            './pages/notifications/notifications-list/notifications-list.component'
          ).then((m) => m.NotificationsListComponent),
      },
      {
        path: 'items',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },

      // Shared Component Redirects
      {
        path: 'delivery-items/items/:deliveryItemId/edit',
        loadComponent: () =>
          import(
            './pages/declarations/declarations-details-wrapper/tabs/delivery-items/edit-delivery-item/edit-delivery-item.component'
          ).then((m) => m.EditDeliveryItemComponent),
      },

      // Legacy / Redirects
      {
        path: 'import-declarations',
        redirectTo: 'shipments/all',
        pathMatch: 'full',
      },
      {
        path: 'financial-overview',
        redirectTo: 'declarations/financial',
        pathMatch: 'full',
      },
      {
        path: 'customs-information',
        redirectTo: 'declarations/info',
        pathMatch: 'full',
      },
      {
        path: 'custom-details',
        redirectTo: 'settings/brokers',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
